import * as React from "react"
import { Center, Spinner } from "@chakra-ui/react"

interface Props {
  h?: string
  w?: string
}

export const Loading = ({ h, w }: Props) => {
  return (
    <Center h={h ?? "100vh"} w={w ?? "100vw"}>
      <Spinner />
    </Center>
  )
}
